<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ep"> </p>
<p class="ep-bot">To learn to write at all, I had to begin by thinking of myself as a sort of fake man.</p>
<p class="epc"><span class="epub-sc">—JOANNA RUSS TO JAMES TIPTREE, JR.</span></p>
<p class="half-space"> </p>
<p class="ep">“For Christ’s sake, Ruth, they’re aliens!”</p>
<p class="ep-bot">“I’m used to it” …</p>
<p class="epc"><span class="epub-sc">—JAMES TIPTREE, JR., “THE WOMEN MEN DON’T SEE”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?bc121b6a